import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import aIbadgeIcon from "../../../assets/images/chats/aIbadgeIcon.svg";
import {
  IndicatorIcon,
  createStyledIndicatorButton,
} from "../../../common/StyledComponents/SideBarComponents";
import CloseIcon from "@mui/icons-material/Close";
import AIAnswerBox from "./AIAnswerBox";
import AIQuestionBox from "./AIQuestionBox";
import TempQuestionBox from "./TempQuestionBox";
import AiEditAnswer from "./AiEditAnswer";
import {
  handleEditAnswer,
  handleGetAiHistory,
} from "../../../appStore/actions/ArkchatGroup/action";
import { useTranslation } from "react-i18next";

import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
import AIQueryInputBox from "./AIQueryInputBox";
import { getCookie } from "../../../config/cookie";

const classes = {
  header: {
    backgroundColor: "#EAEAEA",
    color: "#000",
    padding: "4px 6px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};

const AIQueryPage = forwardRef((props, ref) => {
  const {
    isAiQueryHistory,
    setAiQueryHistory,
    tempAiQuery,
    setTempAiQuery,
    showTempQuery,
    setShowTempQuery,
    isShareAiText,
    setShareAiText,
    setNewMessages,
    setShowStaredAiHistory,
    showStaredAiHistory,
    setSelectedAnswer,
    selecteAnswer,
    setAiQueryValue,
    aiQueryValue,
    setFileAttachment,
    handleClickGoogle,
    handleClickYouTube,
    fileAttachment,
    attachment,
    isTaskUpdateOpen,
    setAttachment,
    setReplyParentMsg,
    replyParentMsg,
    handleMessageSend,
    handleclickAttherate,
    newMessages,
    isThreadScreen,
    setisTopicOpen,
    setMoveTopicTriggered,
    setMoveTopicMsgId,
    setTaskData,
    setTaskUpdateOpen,
    // sessionAiChat,
    // setSessionAiChat,
    // aiChatHistory,
    // setAiChatHistory,
    chatInputWrapper,
  } = props;
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const BadgeButton = createStyledIndicatorButton("#F3F3F3");
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editAnswerData, setEditAnswerData] = useState({});
  const [sessionAiChat, setSessionAiChat] = useState([]);
  const [aiChatHistory, setAiChatHistory] = useState([]);
  const [isStreaming, setIsStreaming] = useState(false);
  const queryContainerRef = useRef(null);

  const selectedGroup = useSelector(
    (state) => state?.appStateData?.selectedGroupData,
  );
  const dispatch = useDispatch();
  const scrollToBottom = () => {
    if (queryContainerRef.current) {
      queryContainerRef.current.scrollTop =
        queryContainerRef.current.scrollHeight;
    }
  };
  const scrollToTop = () => {
    if (queryContainerRef.current) {
      queryContainerRef.current.scrollTop = "0px";
    }
  };

  const handelQuery = async () => {
    if (!aiQueryValue.trim()) return;

    const queryText = aiQueryValue.trim();
    setAiQueryValue("");

    const timeStmp = Math.floor(new Date().getTime()) * 1000;

    setSessionAiChat((prev) => [
      ...prev,
      {
        query: queryText,
        response: "",
        timestamp: Math.floor(new Date().getTime()) * 1000,
      },
    ]);

    setTempAiQuery(queryText);
    setShowTempQuery(true);
    setIsStreaming(true);

    try {
      const response = await fetch(
        `https://arkchat.watchmarket.in/chat/general`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("token")}`,
          },
          body: JSON.stringify({ message: queryText }),
        },
      );

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      let accumulatedText = "";
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          setIsStreaming(false);
          break;
        }

        buffer += decoder.decode(value, { stream: true });

        const lines = buffer.split("\n");
        buffer = lines.pop();

        for (const line of lines) {
          const trimmed = line.trim();
          if (!trimmed) continue;

          let jsonStr = trimmed;

          if (jsonStr.startsWith("data: ")) {
            jsonStr = jsonStr.slice(6).trim();
          }

          if (jsonStr === "[DONE]") continue;

          try {
            const data = JSON.parse(jsonStr);

            if (data?.answer) {
              accumulatedText += data.answer;
              const nextText = accumulatedText;
              setShowTempQuery(false);
              setSessionAiChat((prev) =>
                prev.map((msg) =>
                  msg.timestamp === timeStmp
                    ? { ...msg, response: nextText }
                    : msg,
                ),
              );
            }
          } catch (err) {
            // console.log("Parse error:", err, jsonStr);
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setShowTempQuery(false);
    }
  };

  const handleOpenEditModal = (data) => {
    setEditAnswerData(data);
    setEditModalOpen(true);
  };

  const handleEditDone = () => {
    dispatch(handleEditAnswer(editAnswerData)).then(() => {
      setEditModalOpen(false);
    });
  };

  const handelAnswerChange = (event) => {
    setEditAnswerData({
      ...editAnswerData,
      answer: event.target.value,
    });
  };

  useEffect(() => {
    if (isAiQueryHistory) {
      scrollToTop();
    } else {
      scrollToBottom();
    }
  }, [showTempQuery, isAiQueryHistory, showStaredAiHistory, sessionAiChat]);

  useEffect(() => {
    if (isAiQueryHistory) {
      dispatch(handleGetAiHistory(`general_chat`)).then((res) => {
        setAiChatHistory(res?.data || []);
      });
    }
  }, [isAiQueryHistory]);

  useImperativeHandle(ref, () => ({
    resetQuery() {
      if (isAiQueryHistory) {
        setAiChatHistory([]);
      } else {
        setSessionAiChat([]);
      }
    },
  }));

  return (
    <Box height={"75vh"} display="flex" flexDirection="column">
      <AiEditAnswer
        isEditModalOpen={isEditModalOpen}
        setEditModalOpen={setEditModalOpen}
        editAnswerData={editAnswerData}
        handelAnswerChange={handelAnswerChange}
        handleEditDone={handleEditDone}
      />

      {/* HEADER */}
      {isAiQueryHistory && (
        <Box padding="15px 0px 0px 0px" mb={"0.9rem"}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={classes.header}
          >
            <Typography
              sx={classes.iconDiv}
              onClick={() =>
                showStaredAiHistory
                  ? setShowStaredAiHistory(false)
                  : setAiQueryHistory(false)
              }
            >
              <CloseIcon sx={classes.iconn} />
            </Typography>
            <Typography variant="subtitle2" fontWeight={600} color={"#00000"}>
              {showStaredAiHistory ? "Starred queries" : "Query history"}
            </Typography>
          </Stack>
        </Box>
      )}

      {/* ✅ SCROLLABLE CHAT AREA (TAKES ALL SPACE) */}
      <Box
        sx={{
          flex: 1, // ✅ Important
          overflow: "auto",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "3px",
          },
        }}
        ref={queryContainerRef}
      >
        {!isAiQueryHistory && (
          <Box padding="15px 0px">
            <Box display={"flex"} maxWidth={"90%"}>
              <Box mr={"0.5rem"}>
                <BadgeButton size="small" variant="contained">
                  <IndicatorIcon src={aIbadgeIcon} />
                </BadgeButton>
              </Box>

              <Box>
                <Typography variant="subtitle2">
                  {appContent?.KEY189}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}

        {/* History */}
        {isAiQueryHistory &&
          aiChatHistory?.map((historyData, indx) => (
            <Box mb={"0.9rem"} key={historyData?.id + "historyData" + indx}>
              <AIQuestionBox
                questionData={historyData?.query}
                queried_by={historyData?.queried_by}
                date={historyData?.created_at}
                screenType={"aiHistory"}
              />
              <AIAnswerBox
                answerData={historyData?.response}
                queried_by={historyData?.queried_by}
                date={historyData?.created_at}
                historyData={historyData}
                queryIndx={indx}
                screenType={"aiHistory"}
                isStreaming={isStreaming}
                setShareAiText={setShareAiText}
                setNewMessages={setNewMessages}
                selecteAnswer={selecteAnswer}
                setSelectedAnswer={setSelectedAnswer}
                setAiQueryHistory={setAiQueryHistory}
                setEditModalOpen={setEditModalOpen}
                handleOpenEditModal={handleOpenEditModal}
              />
            </Box>
          ))}

        {/* Session */}
        {!isAiQueryHistory &&
          sessionAiChat?.map((historyData, indx) => (
            <>
              {historyData?.response && (
                <Box mb={"0.9rem"} key={"sessionhistory" + indx}>
                  <AIQuestionBox
                    questionData={historyData?.query}
                    screenType={"aiSession"}
                  />
                  <AIAnswerBox
                    answerData={historyData?.response}
                    queried_by={historyData?.queried_by}
                    history_id={indx}
                    historyData={historyData}
                    screenType={"aiSession"}
                    queryIndx={indx}
                    isStreaming={isStreaming}
                    setShareAiText={setShareAiText}
                    setNewMessages={setNewMessages}
                    selecteAnswer={selecteAnswer}
                    setSelectedAnswer={setSelectedAnswer}
                    setEditModalOpen={setEditModalOpen}
                    handleOpenEditModal={handleOpenEditModal}
                  />
                </Box>
              )}
            </>
          ))}

        {showTempQuery && <TempQuestionBox tempAiQuery={tempAiQuery} />}
      </Box>

      {isShareAiText ? (
        <Box sx={{ mt: "auto" }}>{chatInputWrapper()}</Box>
      ) : (
        <>
          {!isAiQueryHistory && (
            <Box sx={{ mt: "auto" }}>
              <AIQueryInputBox
                setAiQueryValue={setAiQueryValue}
                aiQueryValue={aiQueryValue}
                tempAiQuery={tempAiQuery}
                setTempAiQuery={setTempAiQuery}
                showTempQuery={showTempQuery}
                setShowTempQuery={setShowTempQuery}
                setFileAttachment={setFileAttachment}
                handleClickGoogle={handleClickGoogle}
                handleClickYouTube={handleClickYouTube}
                fileAttachment={fileAttachment}
                attachment={attachment}
                isTaskUpdateOpen={isTaskUpdateOpen}
                setAttachment={setAttachment}
                setReplyParentMsg={setReplyParentMsg}
                replyParentMsg={replyParentMsg}
                setNewMessages={setNewMessages}
                handleMessageSend={handleMessageSend}
                handleclickAttherate={handleclickAttherate}
                newMessages={newMessages}
                selectedGroup={selectedGroup}
                isThreadScreen={isThreadScreen}
                setisTopicOpen={setisTopicOpen}
                setMoveTopicTriggered={setMoveTopicTriggered}
                setMoveTopicMsgId={setMoveTopicMsgId}
                setTaskData={setTaskData}
                setTaskUpdateOpen={setTaskUpdateOpen}
                handelQuery={handelQuery}
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
});

export default AIQueryPage;
